/*
  Barlen: het maatvak boven de kleden.
  - Een maat staat in het adres: ?b=…&l=… (rechthoek, hele centimeters, breedte de kleinste zijde) of ?d=… (rond). De
    kaarten rekenen dan de prijs voor die maat (barlen-kaart.js luistert naar het event "barlen:maat" en meldt daarna
    "barlen:kaarten" met de telling).
  - Tijdens het typen: 400 ms na de laatste toets, en alleen als alle velden kloppen. "Toon prijzen" en Enter doen het
    meteen. Zijn alle velden leeg, dan gaat de maat weg.
  - Een melding verschijnt pas na het verlaten van een veld of na "Toon prijzen", en verdwijnt zodra het klopt.
  - Staan breedte en lengte samen in één veld ("200x300"), dan komen ze in de twee velden terecht.
  - Het kleine vak naast "Veel gezocht" is op de telefoon ingeklapt tot één regel. Die stand staat al in de HTML en de
    CSS, zodat er bij het laden niets verschuift; dit script klapt alleen open en dicht.
  - De grenzen voor de meldingen (kleinste en grootste maat over de kleden op maat) komen uit een kleine sectie van het
    thema (data-mv-grenzen): opgehaald als de pagina rustig is, of meteen bij het eerste gebruik van een vak, en bewaard
    voor dit tabblad. Tot ze er zijn geldt alleen de kleinste maat; een veld dat al verlaten is, wordt opnieuw getoetst.
  - De knop "Vul je maat in" heeft een kleine klik in de HTML, zodat hij ook werkt voordat dit script draait. Dit script
    haalt die weg en neemt de stand over (open blijft open).
  Zonder dit script werkt het vak als gewoon formulier met dezelfde parameters.
*/
(function () {
  'use strict';
  /* Eén keer per pagina, ook als het script twee keer in de pagina staat (Veel gezocht met het vak en de sectie Maatvak). */
  if (window.barlenMaatvak) return;
  window.barlenMaatvak = true;
  var vakken = document.querySelectorAll('form[data-mv]');
  if (!vakken.length) return;
  var telefoon = window.matchMedia ? window.matchMedia('(max-width: 760px)') : { matches: false };
  var WACHT = 400;

  var grenzen = null, wachtenden = [], bezig = false, bronAdres = null;
  try { var bewaard = JSON.parse(sessionStorage.getItem('mv-grenzen') || 'null'); if (bewaard && bewaard.maxb > 0) grenzen = bewaard; } catch (e) {}
  function geefGrenzen(g) { grenzen = g; var w = wachtenden; wachtenden = []; w.forEach(function (fn) { try { fn(g); } catch (e) {} }); }
  function haalGrenzen() {
    if (grenzen || bezig || !bronAdres) return;
    bezig = true;
    fetch(bronAdres, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var m = /<script[^>]*data-mv-grenzen[^>]*>([\s\S]*?)<\/script>/.exec(t || '');
        var g = m ? JSON.parse(m[1]) : null;
        if (!g || !(g.maxb > 0)) { bezig = false; return; }
        try { sessionStorage.setItem('mv-grenzen', JSON.stringify(g)); } catch (e) {}
        geefGrenzen(g);
      })
      .catch(function () { bezig = false; });
  }
  function grenzenVoor(form, fn) {
    if (grenzen) { fn(grenzen); return; }
    wachtenden.push(fn);
    if (!bronAdres) bronAdres = form.getAttribute('data-mv-grenzen');
    form.addEventListener('focusin', haalGrenzen);
    form.addEventListener('pointerdown', haalGrenzen);
  }

  function heel(v) { return v && /^[1-9][0-9]{1,3}$/.test(v) ? parseInt(v, 10) : null; }
  function uitAdres() {
    var q = new URLSearchParams(window.location.search);
    var b = heel(q.get('b')), l = heel(q.get('l')), d = heel(q.get('d'));
    if (b && l) return { rond: false, b: Math.min(b, l), l: Math.max(b, l) };
    if (d) return { rond: true, b: d, l: d };
    return null;
  }
  function maatTekst(S) { return S.rond ? 'Ø ' + S.b + ' cm' : S.b + ' × ' + S.l + ' cm'; }
  function zelfde(a, b) { return (!a && !b) || (!!a && !!b && a.rond === b.rond && a.b === b.b && a.l === b.l); }
  function zetAdres(S) {
    var q = new URLSearchParams(window.location.search);
    q.delete('b'); q.delete('l'); q.delete('d'); q.delete('vorm'); q.delete('page');
    if (S) { if (S.rond) q.set('d', S.b); else { q.set('b', S.b); q.set('l', S.l); } }
    var s = q.toString();
    try { window.history.replaceState(window.history.state, '', window.location.pathname + (s ? '?' + s : '') + window.location.hash); } catch (e) {}
    document.dispatchEvent(new CustomEvent('barlen:maat', { detail: { maat: S } }));
  }

  /* De toets van een ingevulde maat. Geeft per veld een korte melding, en de maat als alles klopt. */
  function toets(vorm, w, G) {
    var f = {}, n = {};
    var velden = vorm === 'Rond' ? ['d'] : ['b', 'l'];
    var naam = { b: 'breedte', l: 'lengte', d: 'diameter' };
    velden.forEach(function (v) {
      var t = String(w[v] || '').trim();
      if (t === '') { f[v] = 'Vul de ' + naam[v] + ' in.'; return; }
      if (/[.,]/.test(t)) { f[v] = 'Alleen hele centimeters.'; return; }
      if (!/^\d+$/.test(t)) { f[v] = 'Alleen cijfers.'; return; }
      var x = parseInt(t, 10);
      if (x < G.min) { f[v] = 'Minimaal ' + G.min + ' cm.'; return; }
      n[v] = x;
    });
    if (vorm === 'Rond') { if (n.d > G.rond) f.d = 'Maximaal Ø ' + G.rond + ' cm.'; }
    else {
      ['b', 'l'].forEach(function (v) { if (n[v] > G.maxL) f[v] = 'Maximaal ' + G.maxL + ' cm lang.'; });
      if (n.b && n.l && !f.b && !f.l) { var k = n.b <= n.l ? 'b' : 'l'; if (n[k] > G.maxB) f[k] = 'Maximaal ' + G.maxB + ' cm breed.'; }
    }
    var ok = !Object.keys(f).length;
    var S = null;
    if (ok) S = vorm === 'Rond' ? { rond: true, b: n.d, l: n.d } : { rond: false, b: Math.min(n.b, n.l), l: Math.max(n.b, n.l) };
    return { ok: ok, fouten: f, S: S };
  }

  function begin(form) {
    var getal = function (a, terug) { var x = parseInt(form.getAttribute(a), 10); return x > 0 ? x : terug; };
    var G = { min: getal('data-mv-min', 50), maxB: getal('data-mv-maxb', Infinity), maxL: getal('data-mv-maxl', Infinity), rond: getal('data-mv-rond', Infinity) };
    var verlaten = {};
    var rij = form.closest('[data-mv-rij]');
    var open = rij ? rij.querySelector('[data-mv-open]') : null;
    var openTekst = open ? open.querySelector('[data-mv-open-tekst]') : null;
    var uitkomst = form.querySelector('[data-mv-uitkomst]');
    var weg = form.querySelector('[data-mv-weg]');
    var huidig = uitAdres();
    var wacht = null;

    var veld = function (n) { return form.querySelector('input[name="' + n + '"]'); };
    var vormVan = function () { var r = form.querySelector('input[name="vorm"]:checked'); return r ? r.value : 'Rechthoek'; };
    var waarden = function () { return { b: veld('b').value, l: veld('l').value, d: veld('d').value }; };
    var leeg = function () { var w = waarden(); return vormVan() === 'Rond' ? w.d.trim() === '' : w.b.trim() === '' && w.l.trim() === ''; };

    function melding(n, t) {
      var i = veld(n); if (!i) return;
      var p = document.getElementById(i.id + '-fout');
      t = t || '';
      if (p && p.textContent !== t) p.textContent = t;
      i.setAttribute('aria-invalid', t ? 'true' : 'false');
    }
    function wisMeldingen() { ['b', 'l', 'd'].forEach(function (n) { melding(n, ''); }); }
    function vormen() {
      var rond = vormVan() === 'Rond';
      form.querySelector('[data-mv-r]').hidden = rond;
      form.querySelector('[data-mv-o]').hidden = !rond;
    }
    function vul(S) {
      var r = form.querySelector('input[name="vorm"][value="' + (S && S.rond ? 'Rond' : 'Rechthoek') + '"]');
      if (r) r.checked = true;
      veld('b').value = S && !S.rond ? S.b : '';
      veld('l').value = S && !S.rond ? S.l : '';
      veld('d').value = S && S.rond ? S.b : '';
      vormen();
    }
    function stand() {
      if (weg) weg.hidden = !huidig;
      if (openTekst) openTekst.textContent = huidig ? 'Jouw maat: ' + maatTekst(huidig) : 'Vul je maat in';
      if (uitkomst && !huidig && uitkomst.innerHTML !== '') uitkomst.innerHTML = '';
    }
    function pas(S) {
      if (zelfde(S, huidig)) return;
      huidig = S;
      stand();
      zetAdres(S);
    }
    function live() {
      clearTimeout(wacht);
      wacht = setTimeout(function () {
        if (leeg()) { pas(null); return; }
        var t = toets(vormVan(), waarden(), G);
        if (t.ok) pas(t.S);
      }, WACHT);
    }
    function klap(dicht) {
      if (!open) return;
      form.classList.toggle('mv-dicht', dicht);
      open.setAttribute('aria-expanded', dicht ? 'false' : 'true');
    }

    /* Breedte en lengte in één veld ("200x300", "200 × 300", "200*300 cm"): over de twee velden verdelen. Bij plakken
       meteen, bij typen pas bij het verlaten van het veld of bij "Toon prijzen". */
    function verdeel(i) {
      if (!i || (i.name !== 'b' && i.name !== 'l')) return false;
      var m = String(i.value).match(/^\s*(\d{2,4})\s*[x×*]\s*(\d{2,4})\s*(?:cm)?\s*$/i);
      if (!m) return false;
      veld('b').value = m[1];
      veld('l').value = m[2];
      melding('b', '');
      melding('l', '');
      return true;
    }

    form.addEventListener('input', function (e) {
      var n = e.target.name;
      if (e.inputType === 'insertFromPaste' || e.inputType === 'insertFromDrop') verdeel(e.target);
      if (n && n !== 'vorm' && e.target.getAttribute('aria-invalid') === 'true') {
        var t = toets(vormVan(), waarden(), G);
        if (!t.fouten[n] || /^Vul de /.test(t.fouten[n])) melding(n, '');
      }
      live();
    });
    form.addEventListener('focusout', function (e) {
      var i = e.target, n = i.name;
      if (!n || n === 'vorm' || i.value.trim() === '') return;
      verlaten[n] = true;
      if (verdeel(i)) { live(); return; }
      var f = toets(vormVan(), waarden(), G).fouten[n] || '';
      if (/^Vul de /.test(f)) f = '';
      melding(n, f);
    });
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'vorm') return;
      vormen();
      wisMeldingen();
      live();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearTimeout(wacht);
      if (vormVan() !== 'Rond' && !verdeel(veld('b'))) verdeel(veld('l'));
      var t = toets(vormVan(), waarden(), G);
      ['b', 'l', 'd'].forEach(function (n) { melding(n, t.fouten[n] || ''); });
      /* Alles leeg: de maat gaat weg (net als tijdens het typen) en de meldingen zeggen wat er nog ontbreekt. */
      if (leeg()) pas(null);
      if (!t.ok) { var eerste = form.querySelector('input[aria-invalid="true"]'); if (eerste) eerste.focus(); return; }
      if (document.activeElement && form.contains(document.activeElement) && document.activeElement.blur) document.activeElement.blur();
      huidig = null;
      pas(t.S);
      if (open && telefoon.matches) { klap(true); open.focus(); }
    });
    form.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mv-weg], [data-mv-wegtekst]')) return;
      /* De knop verdwijnt; wie met het toetsenbord werkt, staat daarna in het eerste veld (op de telefoon niet, dan
         springt het toetsenbord open). */
      var terug = !telefoon.matches && form.contains(document.activeElement);
      clearTimeout(wacht);
      vul(null);
      wisMeldingen();
      pas(null);
      if (terug) { var veld = form.querySelector('.mv-velden:not([hidden]) input'); if (veld) veld.focus({ preventScroll: true }); }
    });
    /* De grenzen gelden zodra ze er zijn, ook voor een veld dat al verlaten is (niet voor het veld waarin iemand typt). */
    grenzenVoor(form, function (g) {
      if (g.min > 0) G.min = g.min;
      if (g.maxb > 0) G.maxB = g.maxb;
      if (g.maxl > 0) G.maxL = g.maxl;
      if (g.rond > 0) G.rond = g.rond;
      Object.keys(verlaten).forEach(function (n) {
        var i = veld(n);
        if (!i || i.value.trim() === '' || i === document.activeElement) return;
        var f = toets(vormVan(), waarden(), G).fouten[n] || '';
        if (/^Vul de /.test(f)) f = '';
        melding(n, f);
      });
    });
    if (open) {
      if (!form.id) form.id = 'mv-vak-' + Math.random().toString(36).slice(2, 8);
      open.setAttribute('aria-controls', form.id);
      /* De klik in de HTML (voor een tik vóór dit script) gaat weg; wie al opende, houdt het vak open. */
      open.removeAttribute('onclick');
      klap(form.classList.contains('mv-dicht'));
      open.addEventListener('click', function () {
        var dicht = !form.classList.contains('mv-dicht');
        klap(dicht);
        if (!dicht) { var i = form.querySelector('.mv-velden:not([hidden]) input'); if (i) i.focus(); }
      });
    }

    /* De regel na het tonen, met de telling van de kaarten. */
    document.addEventListener('barlen:kaarten', function (e) {
      if (!uitkomst) return;
      var d = e.detail || {};
      if (!d.maat || !huidig) { if (uitkomst.innerHTML !== '') uitkomst.innerHTML = ''; return; }
      var knop = '<button type="button" class="mv-wegtekst" data-mv-wegtekst>Maat weghalen</button>';
      var html = d.kan
        ? '<span class="mv-lang"><b>' + d.kan + ' van ' + d.totaal + ' kleden</b> ' + (d.kan === 1 ? 'kan' : 'kunnen') + ' in ' + maatTekst(d.maat) + '</span><span class="mv-kort">In deze maat: <b>' + d.kan + ' van ' + d.totaal + '</b></span>' + knop
        : '<span class="mv-lang"><b>Geen kleed</b> in ' + maatTekst(d.maat) + '</span><span class="mv-kort"><b>Geen kleed</b> in deze maat</span>' + knop;
      if (uitkomst.innerHTML !== html) uitkomst.innerHTML = html;
    });

    /* Terug naar deze pagina uit de cache van de browser: de velden volgen het adres. Alleen dan; bij het gewone laden
       komt "pageshow" pas als alle foto's binnen zijn, en wat iemand intussen al typte, blijft staan. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var S = uitAdres();
      if (zelfde(S, huidig) && (S || leeg())) return;
      huidig = S; vul(S); wisMeldingen(); stand();
      document.dispatchEvent(new CustomEvent('barlen:maat', { detail: { maat: S } }));
    });
    window.addEventListener('popstate', function () { var S = uitAdres(); huidig = S; vul(S); wisMeldingen(); stand(); });

    vul(huidig);
    stand();
  }

  for (var i = 0; i < vakken.length; i++) begin(vakken[i]);

  /* Ophalen als de pagina rustig is, zodat de grenzen er meestal al zijn voordat iemand typt. */
  if (!grenzen) {
    var rustig = function () { if ('requestIdleCallback' in window) window.requestIdleCallback(haalGrenzen, { timeout: 4000 }); else window.setTimeout(haalGrenzen, 2000); };
    if (document.readyState === 'complete') rustig(); else window.addEventListener('load', rustig, { once: true });
  }
})();
